import * as yup from 'yup';

const sdlNumberRegExp = /^L\d\d\d\d\d\d\d\d\d$/;

export const OrganisationDetailsValidationSchema = yup.object().shape({
    sdlNumber: yup.string().required('SDL No. is required').matches(sdlNumberRegExp, 'SDL No. must start with an L followed by 9 digits eg. L000000000'),
    sicCode: yup.string().nullable()
}
);